import axios from 'axios'
import store from '@/store'
import router from '@/router'

export default {
  async execute (method, resource, data) {
    // inject the accessToken for each request
    let accessToken = await store.getters.token
    return axios({
      method,
      json: true,
      url: resource,
      data,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }).then(req => {
      if (req.data.token) {
        store.dispatch('newToken', req.data.token)
      }
      return req.data
    }).catch(error => {
      const { response } = error
      const { request, ...errorObject } = response // take everything but 'request'
      if (errorObject.status === 401) {
        store.dispatch('LogOut')
        router.push('/Projekte')
      }
      if (errorObject.status === 500) {
        return {'errorMessage': 'Server Error: ' + errorObject.data.details}
      }
    })
  },
  action (action, id, data) {
    return this.execute('post', `/api/ws/action/${action}/${id}`, data)
  },
  auftraege (offset, size) {
    return this.execute('get', `/api/ws/auftraege/${offset}/${size}`)
  },
  anfragen (offset, size) {
    return this.execute('get', `/api/ws/anfragen/${offset}/${size}`)
  },
  archiv (offset, size, data) {
    let params = '?'
    for (let key of Object.keys(data)) {
      if (data[key]) {
        params = params + key + '=' + data[key] + '&'
      }
    }
    return this.execute('get', `/api/ws/archiv/${offset}/${size}` + params)
  },
  cutterauftraege (id, offset, size) {
    return this.execute('get', `/api/ws/cutterauftraege/${id}/${offset}/${size}`)
  },
  simpleAction (id, message) {
    return this.execute('get', `/api/ws/simpleAction/${id}/${message}`)
  },
  get (id) {
    return this.execute('get', `/api/ws/get/${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/main/vue/api/workflow.js